'use client';

import { useEffect, useRef, useState } from 'react';

export default function RosterUploader(props: { onParsed?: (roster: unknown) => void }) {
  const [status, setStatus] = useState('Waiting for file...');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const el = inputRef.current;
    if (!el) {
      setStatus('NO REF YET');
      return;
    }

    const onChange = () => {
      const file = el.files?.[0];
      setStatus(`NATIVE CHANGE: ${file?.name || 'no file'}`);
    };
    const onInput = () => {
      const file = el.files?.[0];
      setStatus(`NATIVE INPUT: ${file?.name || 'no file'}`);
    };

    el.addEventListener('change', onChange);
    el.addEventListener('input', onInput);

    return () => {
      el.removeEventListener('change', onChange);
      el.removeEventListener('input', onInput);
    };
  }, []);

  return (
    <div className="flex flex-col items-center gap-4 w-full max-w-md p-8 border-2 border-dashed rounded-lg border-zinc-300 dark:border-zinc-700">
      <p className="text-zinc-600 dark:text-zinc-400 text-lg font-medium">
        Select a roster file
      </p>
      <p className="text-sm text-zinc-500">{status}</p>
      <input
        ref={inputRef}
        type="file"
        accept=".xlsx,.xlsm"
        onClick={() => setStatus('INPUT CLICKED')}
      />
    </div>
  );
}
